<template>
  <section class="feature-section" :style="styles">
    <div class="grid grid--container feature-section__container">
      <div class="feature-section__content" v-if="title">
        <VText class="feature-section__title" variant="h2">{{ title }}</VText>
        <div v-if="$slots.text" class="feature-section__text">
          <slot name="text" />
        </div>
        <div class="feature-section__cta" v-if="$slots.cta">
          <slot name="cta" />
        </div>
      </div>

      <FeatureGrid>
        <slot />
      </FeatureGrid>

      <slot name="after" />
    </div>
  </section>
</template>

<script>
import { VText, useTheme, getThemeColor } from '@campsite-bio/component-lib';
import { computed } from '@nuxtjs/composition-api';

import FeatureGrid from '@/components/features/feature-grid';

export default {
  components: {
    VText,
    FeatureGrid,
  },

  props: {
    title: {
      type: String,
      default: null,
    },

    bgColor: {
      type: String,
      default: 'white',
    },
  },

  setup(props) {
    const theme = useTheme();

    const styles = computed(() => ({
      '--c-bg-color': getThemeColor(props.bgColor, theme.value),
    }));

    return { styles };
  },
};
</script>

<style lang="scss" scoped>
.feature-section {
  background-color: var(--c-bg-color);

  &__container {
    padding-bottom: 5.5rem;
    padding-top: 6rem;
    max-width: 1140px;
  }

  &__content {
    max-width: 780px;
    margin: 0 auto 3rem;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  &__text {
    ::v-deep p {
      font-size: 1.25rem;
    }
  }

  &__cta {
    margin-top: 1.5rem;
  }
}

.feature-section__title.feature-section__title {
  margin-bottom: 1rem;
}
</style>
